import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

export const AcceptBidDialog = ({
  open,
  onClose,
  onConfirm,
  sending,
  precio,
  proveedor,
  cantidad,
  um,
  FormatPrice,
  canCreateOc,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Confirmar adjudicación</DialogTitle>
    <DialogContent>
      <Typography variant="body2">
        Se adjudicará <strong>$ {FormatPrice(precio)}</strong>
        {proveedor ? ` de ${proveedor}` : ''}
        {cantidad ? ` · ${FormatPrice(cantidad)} ${um || ''}` : ''}.
      </Typography>
      <Typography variant="body2" sx={{ mt: 1 }}>
        La sala se cerrará para el resto de oferentes.
      </Typography>
      <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
        {canCreateOc
          ? 'Se intentará crear la orden de compra. Si falla, quedará la cotización ganadora.'
          : 'Quedará como cotización ganadora si no se puede generar la OC.'}
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={sending}>Cancelar</Button>
      <Button variant="contained" onClick={onConfirm} disabled={sending} autoFocus>
        Aceptar y adjudicar
      </Button>
    </DialogActions>
  </Dialog>
);
